export const priceCatalog = {
  'priceCatalog.previousPublication': 'הפרסום הקודם',
  'priceCatalog.currentPublication': 'הפרסום הנוכחי',
  'priceCatalog.name': 'שם',
  'priceCatalog.state': 'מצב',
  'priceCatalog.active': 'פעיל',
  'priceCatalog.archived': 'בארכיון',
  'priceCatalog.open': 'פתיחת {name}',
  'priceCatalog.empty': 'אין פרסומים',
  'priceCatalog.emptyDetail': 'טרם פורסמו כאן תנאים מסחריים.',
  'priceCatalog.publication': 'פרסום',
  'priceCatalog.taxPublication': 'פרסום מס',
  'priceCatalog.newPublication': 'עריכה לפרסום',
  'priceCatalog.publish': 'פרסום תנאים',
  'priceCatalog.archive': 'העברה לארכיון',
  'priceCatalog.saving': 'שמירה…',
  'priceCatalog.from': 'בתוקף מתאריך',
  'priceCatalog.until': 'עד לתאריך, לא כולל',
  'priceCatalog.addInterval': 'הוספת תקופה',
  'priceCatalog.adjustments': 'התאמות מחיר',
  'priceCatalog.addAdjustment': 'הוספת התאמה',
  'priceCatalog.key': 'קוד כלל',
  'priceCatalog.order': 'סדר החלה',
  'priceCatalog.adjustmentKind': 'התאמה',
  'priceCatalog.fixedDiscount': 'הנחה בסכום קבוע',
  'priceCatalog.percentDiscount': 'הנחה באחוזים',
  'priceCatalog.fixedSurcharge': 'תוספת בסכום קבוע',
  'priceCatalog.percentSurcharge': 'תוספת באחוזים',
  'priceCatalog.percent': 'אחוזים',
  'priceCatalog.amount': 'סכום',
  'priceCatalog.cap': 'תקרת התאמה, רשות',
  'priceCatalog.basis': 'בסיס החישוב',
  'priceCatalog.originalGross': 'המחיר המקורי כולל מס',
  'priceCatalog.runningGross': 'המחיר לאחר התאמות קודמות',
  'priceCatalog.stacking': 'שילוב',
  'priceCatalog.stack': 'בשילוב עם התאמות אחרות',
  'priceCatalog.exclusive': 'התאמה בלעדית',
  'priceCatalog.reason': 'סיבה',
  'priceCatalog.reasonRequired': 'יש להזין סיבה בת שלושה תווים לפחות.',
  'priceCatalog.remove': 'הסרה מהטיוטה',
  'priceCatalog.rateKind': 'סוג שיעור המס',
  'priceCatalog.percentRate': 'אחוז',
  'priceCatalog.fixedRate': 'היטל קבוע',
  'priceCatalog.fixedUnitAmount': 'היטל ליחידת שירות',
  'priceCatalog.addRate': 'הוספת שיעור מס',
  'priceCatalog.priceTaxMode': 'מס ומחיר השירות',
  'priceCatalog.additional': 'מתווסף למחיר',
  'priceCatalog.rateUnavailable': 'שיעור המס שנבחר אינו בתוקף בתאריך זה. יש לבחור במפורש שיעור מס בתוקף.',
  'priceCatalog.taxSchedule': 'שיעורי מס',
  'priceCatalog.treatment': 'סוג המס',
  'priceCatalog.included': 'כלול במחיר המלא',
  'priceCatalog.zero': 'שיעור אפס',
  'priceCatalog.exempt': 'פטור',
  'priceCatalog.rate': 'שיעור באחוזים',
  'priceCatalog.addComponent': 'הוספת רכיב מס',
  'priceCatalog.unsaved': 'תנאים מסחריים שלא פורסמו',
  'priceCatalog.readOnly': 'ההרשאות הנוכחיות או מצב הקטלוג אינם מאפשרים שינוי.',
  'priceCatalog.loadFailed': 'לא ניתן לטעון את הקטלוג.',
  'priceCatalog.failed': 'לא ניתן לשמור את הפרסום. הטיוטה נשמרה.',
  'priceCatalog.invalid': 'התנאים נדחו. יש לבדוק תאריכים, מקורות, סכומים וסדר כללים.',
  'priceCatalog.changed': 'הקטלוג או מקור שנבחר השתנו. יש לטעון מחדש לפני הפרסום.',
  'priceCatalog.profileMissing': 'נדרש פרופיל כספי לפני פרסום מחירים.',
  'priceCatalog.currencyChanged': 'מטבע הטיוטה שונה מפרופיל המרפאה הנוכחי. אין להשתמש שוב בסכומים הישנים.',
  'priceCatalog.sourceUnavailable': 'שירות, סניף או מקור מס נדרש אינם זמינים.',
  'priceCatalog.incomplete': 'יש להשלים שם ותקופות לפני הפרסום.',
  'priceCatalog.reload': 'טעינת התנאים השמורים מחדש',
  'priceCatalog.reloadFailed': 'הטעינה מחדש נכשלה. הטיוטה נשמרה.',
  'priceCatalog.reloaded': 'התנאים השמורים נטענו. יש לבדוק אותם לפני הפרסום.',
} as const
